import React from "react";
import './Aboutcmdmessage.css';
// const cmdimg = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742274318/Group103_t6gxto.png";
const cmd="https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273198/09_u0xynl.png";

const Aboutcmd = () => {
    return (
        <>
            <div className="cmd-message">
                <div className="cmd-img">
                    <h3>MESSAGE</h3>
                    <img src={cmd} alt="" />
                </div>
                <div className="cmd-content">
                    <p className="cmdtext">"Life on a farm teaches patience; crops can't be rushed, and progress can't be forced. Growing up surrounded by my family's guidance, We've witnessed the farmer's life up close. Farming is a noble yet demanding profession that appears deceptively simple from a far.</p>
                    <p className="cmdtext">Agriculture has fueled our nation's progress. The least we can do to repay farmers' hard work is support them with innovative, sustainable solutions. As a proponent of Sustainable Agriculture Mechanization, I'm committed to developing products that are:-</p>
                    <ul className="cmdlist">
                        <li>Fuel-efficient</li>
                        <li>Economical</li>
                        <li>Environment-friendly</li>
                        <li>Labour-saving</li>
                        <li>Soil-quality preserving</li>
                    </ul>
                    <p className="cmdtext">I'm proud that our team shares this vision, leveraging Agro-technology to empower farmers. We're also backing Initiatives that promote creative methods for increasing yields and profits while reducing costs and fatigue,</p>
                    <p className="cmdcapital">KUDOS TO AGRICULTURE, THE BACKBONE OF OUR CULTURE!</p>
                </div>
            </div>
            {/* <div className="about-smd-hding">
                <h1>CMD's MESSAGE</h1>
                <div className="row">
                    <div className="col-lg-6 col-md">
                        <div className="image-container">
                            <img src={cmdimg} alt="S. Amar Singh" />
                            <p className="name">S. Amar Singh</p>
                            <p className="position">(CMD, DASMESH Group)</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md">
                        <div className="message">
                            <p>Life on a Farm is a school of patience. You can't hurry the crops or make it in two days. Growing up with such valuable guidance from my family, I have seen and observed the farmers' life up close. And undoubtedly, farming is the most virtuous yet most demanding of all professions which looks mighty easy when your plow. It is through agriculture that our nation has progressed so much. The least we all can do for a farmer in return of his toil and hard work is to support him through innovative products and suggest ways to increase his productivity.</p>
                            <p>As a strong contender of Sustainable Agriculture Mechanization, I would like my team to focus on such products that are fuel efficient, economical, and environment-friendly and improves the efficiency of human time and labour without degrading quality of the soil or other factors of production. It makes me happy that everyone in our group shares this vision and is relentlessly trying to help our farmer-friends get an edge through Agro technology. We are also supporting many ventures and initiatives that are meant for spreading creative ways that farmers can use to increase yields and profits while decreasing input costs and fatigue.</p>

                        </div>
                        <p className="highlight">Kudos to the agriculture. The most respectful of all cultures!</p>
                    </div>
                </div>
                
            </div> */}
        </>
    )
};

export default Aboutcmd;